// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608110904/js/" + chunkId + "." + {"44":"e765e925","225":"062243f9","481":"1034d407","486":"2a533220","770":"2cf3e81a"}[chunkId] + ".0.058479716919670355.chunk.js";
};